import { forwardRef, Ref } from 'react';
import { Separator } from '@cld/navigation-menu';
import { HorizontalSeparator } from '@clds/separator';
import { SIDE_MENU_SESSION_STORAGE_KEY } from '../../ApplicationWrapper.const';
import { useSideMenu } from './SideMenu.context';
import { SideMenuProps } from './SideMenu.types';
import { StyledSideMenu, StyledCollapsiblePanel, StyledSection, StyledSectionContent, StyledSectionTop, HeaderPadding } from './SideMenu.styled';

export const SideMenuCommon = forwardRef<HTMLElement, SideMenuProps>(({ header, footer, children }, ref) => (
  <StyledSideMenu ref={ref as Ref<HTMLDivElement>} noPadding={!header}>
    <StyledSectionTop>
      {header && <HeaderPadding>{header}</HeaderPadding>}
      {header && <HorizontalSeparator horizontalMargin="sm" verticalMargin="sm" />}
      <StyledSectionContent>{children}</StyledSectionContent>
    </StyledSectionTop>
    <StyledSection>
      {footer && (
        <>
          <Separator />
          {footer}
        </>
      )}
    </StyledSection>
  </StyledSideMenu>
));

export const SideMenu = forwardRef<HTMLElement, SideMenuProps>(({ header, footer, children, ...rest }, ref) => {
  const { setSideMenuOpen } = useSideMenu();
  return (
    // @ts-ignore Effect of importing apps from apps - remove after full migration @fe-infra
    <StyledCollapsiblePanel
      showCollapseOnHover
      isFloatOnHover
      isContentHiddenOnClose
      notchSize={20}
      sessionStorageKey={SIDE_MENU_SESSION_STORAGE_KEY}
      onFloatChange={setSideMenuOpen}
      toggleCallback={setSideMenuOpen}
      {...rest}
    >
      <SideMenuCommon ref={ref} header={header} footer={footer} children={children} />
    </StyledCollapsiblePanel>
  );
});
